'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dropdownChangeHandler = exports.createQuery = exports.ToRemove = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toKeepCats = {
    Asphalt: ['Dried', 'Fine'],
    Brick: ['Floor', 'Grout', 'Modern', 'Painted', 'Rough'],
    Bush: [],
    Climber: [],
    Concrete: ['Damaged', 'Painted', 'Slab', 'Smooth'],
    Construction: [],
    Debris: ['Construction', 'Nature'],
    Decals: ['Manhole cover', 'Misc', 'Painted Street Lines', 'Rock', 'Sidewalk', 'Snow', 'Wood'],
    Displacement: [],
    Edible: [],
    Fabric: [],
    Floors: [],
    Flowers: [],
    Grass: [],
    Ground: [],
    Imperfections: [],
    Metal: [],
    Misc: [],
    Moss: [],
    Paintings: [],
    Paper: ['Cardboard', 'Crumpled', 'Plain'],
    Plants: [],
    Plaster: [],
    Plastic: [],
    Rock: [],
    Sand: ['Coarse', 'Fine'],
    Scatter: [],
    Snow: [],
    Soil632: ['Cracked', 'Hardened', 'Mulch'],
    Stone: [],
    Street165: ['Barriers', 'Curbs', 'Painted Lines', 'Sidewalk'],
    Tiles: [],
    Tree: [],
    Wall: [],
    Wood: []
};

var catsToKeep = ['Asphalt', 'Brick', 'Bush', 'Climber', 'Concrete', 'Construction', 'Debris', 'Decals', 'Fabric', 'Floors', 'Grass', 'Ground', 'Imperfections', 'Metal', 'Paintings', 'Plants', 'Plaster', 'Plastic', 'Rock', 'Sand', 'Scatter', 'Snow', 'Soil', 'Stone', 'Street', 'Tiles', 'Tree', 'Wall', 'Wood'];
var subCatsToKeep = ['Dried', 'Fine', 'Floor', 'Grout', 'Modern', 'Painted', 'Rough', 'Damaged', 'Painted', 'Slab', 'Smooth', 'Nature', 'Manhole cover', 'Painted Street Lines', 'Sidewalk', 'Cardboard', 'Crumpled', 'Plain', 'Coarse', 'Fine', 'Cracked', 'Hardened', 'Mulch', 'Barriers', 'Curbs', 'Painted Lines', 'Sidewalk'];

// - Asphalt 70
// - Brick
// - Bush (180)
// - Climber (48)
// - Concrete
// - Construction
// - Debris
// - Decals
// - Fabric
// - Floors
// - Grass
// - Ground
// - Imperfections
// - Metal
// - Paintings
// - Plants
// - Plaster
// - Plastic
// - Rock
// - Sand
// - Scatter
// - Snow
// - Soil632
// - Stone
// - Street165
// - Tiles
// - Tree
// - Wall
// - Wood


//SUBCATS
// - Dried
// - Fine
// - Floor
// - Grout
// - Modern
// - Painted
// - Rough
// - Damaged
// - Painted
// - Slab
// - Smooth
// - Nature
// - Manhole cover
// - Painted Street Lines
// - Sidewalk
// - Cardboard
// - Crumpled
// - Plain
// - Coarse
// - Fine
// - Cracked
// - Hardened
// - Mulch
// - Barriers
// - Curbs
// - Painted Lines
// - Sidewalk


// export const toRemoveSubCats = [
// 'coarse',
// 'cracked',
// 'fresh',
// 'patch',
// 'pothole',
// 'medieval',
// 'mud',
// 'rubble',
// 'barrier',
// 'dirty',
// 'construction',
// 'dirt',
// 'food',
// 'manmade',
// 'paper',
// 'trash',
// 'blood',
// 'crack',
// 'misc',
// 'pothole',
// 'rock',
// 'snow',
// 'wood',
// 'books',
// 'debris',
// 'mud',
// 'rough',
// 'dirt',
// 'patches',
// 'potholes',
// ]

var ToRemove = exports.ToRemove = ['coarse', 'cracked', 'fresh', 'patch', 'pothole', 'medieval', 'mud', 'rubble', 'displacement', 'edible', 'flowers', 'misc', 'moss', 'ocean', 'paper', 'construction', 'dirt', 'food', 'manmade', 'paper', 'trash', 'blood', 'crack', 'misc', 'pothole', 'rock', 'snow', 'wood', 'brushes', 'creature', 'books', 'debris', 'mud', 'rough', 'dirt', 'patches', 'potholes'];

var createQuery = exports.createQuery = function createQuery(query, key, value) {
    var exclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    return (0, _index.cleanObj)((0, _extends4.default)({}, _ramda2.default.omit(exclude, query), (0, _defineProperty3.default)({}, key, value === 'all' ? null : value)));
};

var dropdownChangeHandler = exports.dropdownChangeHandler = function dropdownChangeHandler(pathname, router, query, key) {
    return function (ev) {
        router.push({
            pathname: pathname,
            query: createQuery(query, key, ev.target.value, key === 'type' && ['category', 'subCategory'])
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/libraryNav.js
// module id = 2770
// module chunks = 0